import { useEffect, useState, useRef } from 'react';
// import Handsontable from 'handsontable/base';
// import 'handsontable/dist/handsontable.full.min.css';
// import { registerAllModules } from 'handsontable/registry';
// import { HotTable } from '@handsontable/react';
import SimpleExcel from './components/SimpleExcel';
import { Button, Calendar, MessageBox, Select, message } from 'kenshin';
import ReactDOM from 'react-dom';
// import { registerRenderer } from 'handsontable/renderers';
// import { registerCellType } from 'handsontable/cellTypes';
// import installCell from './_tools/installCell';
// import { registerLanguageDictionary, zhCN } from 'handsontable/i18n';
import { connect } from 'umi';
import TabsComponent from './components/TabsComponent';
import OperationBar from './components/OperationBar';
import RptModal from '../../usercenter/rptAudit/components/RptModal';
import ServiceCategoryModal from '../taskManage/components/ServiceCategoryModal';
import CopyTaskModal from './components/CopyTaskModal';
import './index.less';
import createColumns from './columns';
import { getProServcatgTree, getTaskTagList } from '@/_serveice/project';
import {
  gettaskplanexcelsheetpage,
  gettaskplanexcellist,
  saveupdatetaskplanexcelsheet,
  saveupdatetaskplanexcel,
  removetaskplanexceldata,
  deletetaskplanexcelsheet,
  gettorelataskplanpageexcel,
  deletetask,
  copytaskplanexcelrow,
  movetaskplanexcelrow,
  refertaskplanexcelrow,
} from '@/_serveice/task';
import { useReactive } from 'ahooks';
import { getAllEmployee } from '@/_serveice/admin/system';
import { copyToClipboard, deepClone, uniqueArrayById } from '@/_util';
import PageLoading from '@/components/pageLoading';

/*

操作类型:0:所有列数据;1:任务名称;2:工作包;3:责任人;4:对接人;5:参与人;6:需求|方案是否确认;7:优先级;8:Excel中状态;9:执行类别;10:开始时间;11:结束时间;12:备注;

*/
const TYPE_KEY = {
  '*': 0,
  taskName: 1,
  proServCatgId: 2,
  taskLeader: 3,
  taskDockId: 4,
  addTaskTeamMemberList: 5,
  taskRfpConfirm: 6,
  taskPriority: 7,
  taskExcelStatus: 8,
  taskDoType: 9,
  taskBeginTime: 10,
  taskEndTime: 11,
  taskRemark: 12,
  taskTagList: 13,
};

// 允许操作的角色
const ROLE = ['PROJECT:MANAGER', 'PROJECT:PLAN', 'SUPERADMIN'];
// const ROLE = ['PROJECT:MANAGER', 'PROJECT:PLAN'];

const taskListMap = {};

// 扁平化tree
export const flattenTree = (tree) => {
  let result = [];
  tree.forEach((item) => {
    result.push(item);
    if (item.childList) {
      result = result.concat(flattenTree(item.childList));
    }
  });
  return result;
};

// registerLanguageDictionary(zhCN);
// registerAllModules();
// installCell();

let timer = null;

const ExcelPro = ({ dispatch, project, customer, usercenter, loading }) => {
  const MapData = useRef([{}]);
  const hotTableComponent = useRef(null);
  const [activeTab, setActiveTab] = useState('tab1');
  const [tabs, setTabs] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [rptModalVisible, setRptModalVisible] = useState(false);
  const [timeData, setTimeData] = useState({});
  const [selectRows, setSelectRows] = useState([]);
  const [selectKeys, setSelectKeys] = useState([]);
  const reportDate = +new Date();
  const [pageLoading, setLoading] = useState(false);

  const [tagModalVisible, setTagModalVisible] = useState(false);
  const [currentTagRow, setCurrentTagRow] = useState(null);
  const [currentTagValue, setCurrentTagValue] = useState(undefined);
  const [currentProServCatgId, setCurrentProServCatgId] = useState(undefined);

  const [copyModalVisible, setCopyModalVisible] = useState(false);
  const [currentCopyTask, setCurrentCopyTask] = useState(null);
  const [actionType, setActionType] = useState('copy');
  const [selectedTaskIds, setSelectedTaskIds] = useState([]);

  const handleTagClick = (rowData, rowIndex) => {
    if (!rowData._proServCatgId) {
      message.error('请先选择工作包');
      return;
    }
    setCurrentTagRow(rowIndex);
    // Extract IDs for Select component
    const tagIds = Array.isArray(rowData.taskTagList)
      ? rowData.taskTagList.map((item) => item.id)
      : [];
    setCurrentTagValue(tagIds);
    setCurrentProServCatgId(rowData._proServCatgId);
    setTagModalVisible(true);
  };

  const handleTagSave = (tags) => {
    if (currentTagRow !== null) {
      // const sourceData = hotTableComponent.current.hotInstance.getSourceData();
      // if (sourceData[currentTagRow]) {
      //   // Update display text
      //   sourceData[currentTagRow].taskTagName = tags
      //     .map((o) => o.value)
      //     .join(',');
      //   // Update taskTagList structure for renderer
      //   sourceData[currentTagRow].taskTagList = tags.map((o) => ({
      //     id: o.id,
      //     value: o.value,
      //   }));
      // }

      const sourceData = MapData.current;
      if (sourceData[currentTagRow]) {
        // Update display text
        sourceData[currentTagRow].taskTagName = tags
          .map((o) => o.value)
          .join(',');
        // Update taskTagList structure for renderer
        sourceData[currentTagRow].taskTagList = tags.map((o) => ({
          id: o.id,
          value: o.value,
        }));
      }

      const colIndex =
        hotTableComponent.current.hotInstance.propToCol('taskTagList');
      // Pass full objects so MapData stays consistent with renderer expectations
      hotTableComponent.current.hotInstance.setDataAtCell(
        currentTagRow,
        colIndex,
        tags.map((o) => ({ id: o.id, value: o.value })),
      );
      hotTableComponent.current.hotInstance.render();
    }
    setTagModalVisible(false);
  };

  if (hotTableComponent.current) {
    window.hotTableComponent = hotTableComponent.current;
  }
  console.log('tabs', tabs);

  let roleList =
    JSON.parse(localStorage.getItem('employeeDTO') || '{}')?.roleList?.map(
      (it) => it.extendData,
    ) || [];
  const disabled = !roleList.some((role) => ROLE.includes(role));

  // 将showRptModal方法挂载到window上，供columns.js调用
  window.showRptModal = (row) => {
    setSelectRows([row]);
    setSelectKeys([row.taskId]);
    setProServcatgHourList();
    MessageBox.confirm({
      title: '选择日期',
      icon: null,
      content: (
        <Calendar
          onSelect={(date) => {
            dispatch({
              type: 'usercenter/save',
              payload: {
                empCurTimesLot: [],
              },
            });
            state.reportDate = +new Date(date);
            getHasRptTime(moment(state.reportDate).format('YYYY-MM-DD'));
            setRptModalVisible(true);
          }}
        />
      ),
    });
  };

  const setProServcatgHourList = () => {
    let selectKeys = selectRows.map(
      (item) => `${item.projectId}-${item.proServCatgId}`,
    );
    let projectKeys = Array.from(
      new Set(selectKeys.map((item) => item.split('-')[0])),
    );
    let projectServCatgList = projectKeys.map((item) => ({
      projectId: item,
      servCatgList: selectKeys
        .filter((ids) => ids.startsWith(item))
        .map((item) => item.split('-')[1]),
    }));
    dispatch({
      type: 'usercenter/getProServcatgHourList',
      payload: {
        empIdString: localStorage.getItem('muId'),
        projectServCatgList,
      },
    }).then((res) => {
      if (res && Array.isArray(res)) {
        let rseData = {};
        res.map((item) => {
          let obj = {};
          obj.projectCurTime = item.projectWorkHour?.extendData;
          obj.projectTime = item.projectWorkHour?.value;
          item.proServCatgWorkHourList.map((serv) => {
            obj[`${item.projectWorkHour.id}_${serv.id}`] = serv.value;
          });
          rseData[item.projectWorkHour.id] = obj;
        });
        setTimeData(rseData);
      }
    });
  };

  const getHasRptTime = (reportDate) => {
    if (!reportDate) {
      return null;
    }
    return dispatch({
      type: 'usercenter/getEmpCurTimesLotList',
      payload: {
        empId: localStorage.getItem('muId'),
        reportDate,
      },
    });
  };

  const rptSave = (val) => {
    let reasonTime = true;
    let emptyTime = false;
    val.map((item) => {
      item.rptWorkTotalHours = +(
        item.rptWorkOvertimeHours + item.rptWorkHours
      ).toFixed(2);
      item.overTimePercent =
        +(item.rptWorkOvertimeHours / item.rptWorkTotalHours).toFixed(2) || 0;
    });
    if (!reasonTime) {
      message.error('时间段不能超过24小时');
      return;
    }
    dispatch({
      type: 'usercenter/reportEmpWork',
      payload: {
        empIdString: localStorage.getItem('muId'),
        rptWorkDetailList: val,
      },
    }).then((res) => {
      if (res) {
        message.success('上报成功');
        setRptModalVisible(false);
      }
    });
  };

  useEffect(() => {
    dispatch({
      type: 'project/getSimpProjectList',
    });
    init();
  }, []);

  // 获取sheet数据并更新tabs状态
  const getSheetData = (taskExcelSheetId, tabId) => {
    console.log('重新获取数据');
    setLoading(true);
    return gettaskplanexcellist({ taskExcelSheetId }).then((res) => {
      if (res.data) {
        setLoading(false);
        setTabs((tabs) =>
          tabs.map((tab) => {
            if (tab.id === tabId) {
              let data = Array.isArray(res.data) ? res.data : [];
              data = data.map((item, index) => {
                return {
                  ...item,
                  taskRfpConfirm: !!item.taskRfpConfirm,
                  proServCatgId: item.servCatgName,
                  _proServCatgId: item.proServCatgId,
                  _baseData: true,
                  taskTagList: item.taskTagList || [],
                  addTaskTeamMemberList: item.dbTaskTeamMemberList
                    ?.map((item) => item.teamMemberId)
                    .join(','),
                };
              });
              if (!data.length) data = [new Array(columns.length).fill('')];
              MapData.current = JSON.parse(JSON.stringify(data));
              setSelectedTaskIds([]); // Clear selection on data refresh
              return { ...tab, data };
            }
            return tab;
          }),
        );
      }
    });
  };

  let columns = createColumns({ project, customer, employee, handleTagClick });
  columns = columns.map((col) => ({
    ...col,
    readOnly: col.readOnly || disabled,
    disabled,
  }));

  const state = useReactive({
    sheetList: [],
    reportDate: +new Date(),
    pageNo: 1,
    totalPage: 1,
  });

  // 处理切换
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    const currentTab = tabs.find((tab) => tab.id === tabId);
    MapData.current = deepClone(currentTab.data);

    // Recalculate selected task IDs for the new tab
    const ids = MapData.current
      .filter((item) => !!item.checked && item.taskId)
      .map((item) => item.taskId);
    setSelectedTaskIds(ids);
    console.log('MapData.current', MapData.current, ids);

    if (
      currentTab?.taskExcelSheetId &&
      (!currentTab.data || !currentTab.data.length)
    ) {
      getSheetData(currentTab.taskExcelSheetId, tabId);
    }
    // 如果是最后一个tab且还有下一页，加载下一页数据
    if (tabId === tabs[tabs.length - 1]?.id && state.pageNo < state.totalPage) {
      state.pageNo++;
      gettaskplanexcelsheetpage({
        page: {
          pageNo: state.pageNo,
          pageSize: 5,
        },
      }).then((res) => {
        if (res.data?.datas?.length) {
          const newTabs = res.data.datas.map((sheet) => ({
            id: sheet.taskExcelSheetId,
            name: sheet.excelSheetName,
            data: [],
            taskExcelSheetId: sheet.taskExcelSheetId,
          }));
          setTabs([...tabs, ...newTabs]);
          MapData.current = deepClone([...tabs, ...newTabs]);
        }
        state.totalPage = res.data?.totalPage || 1;
      });
    }
  };

  const init = (reset = true) => {
    setLoading(true);
    state.pageNo = 1;
    gettaskplanexcelsheetpage({
      page: {
        pageNo: state.pageNo,
        pageSize: 50,
      },
    }).then((res) => {
      setLoading(false);
      if (res.data?.datas?.length) {
        const sheetList = res.data.datas;
        const initTabs = sheetList.map((sheet) => {
          return {
            id: sheet.taskExcelSheetId,
            name: sheet.excelSheetName,
            data: [], // 稍后通过getSheetData获取数据
            taskExcelSheetId: sheet.taskExcelSheetId,
          };
        });

        setTabs(initTabs);
        let i = 0;
        if (!reset) {
          i = initTabs.findIndex((item) => item.id === activeTab);
          if (i === -1) i = 0;
        }
        setActiveTab(initTabs[i].id);
        // 获取第一个sheet的数据
        getSheetData(initTabs[i].taskExcelSheetId, initTabs[i].id);
        state.totalPage = res.data?.totalPage || 1;
      } else {
        // 如果没有sheet，则自动创建一个新的sheet
        handleTabAdd();
      }
    });
    getAllEmployee().then((res) => {
      let employeeList = res.data
        .map((item) => item.employeeList)
        .flat(2)
        .map((item) => ({
          label: (
            <div
              style={{ display: 'flex', alignItems: 'center' }}
              data-label={item.value}
            >
              <img
                src={item.extendData2}
                style={{ width: 18, height: 18, borderRadius: '50%' }}
              />
              {item.value}
            </div>
          ),
          value: item.id,
        }));
      setEmployee(employeeList);
    });
  };

  // 处理新增
  const handleTabAdd = (itemTab) => {
    if (itemTab) {
      setTabs([itemTab, ...tabs]);
      setActiveTab(itemTab.id);
      getSheetData(itemTab.taskExcelSheetId, itemTab.id);
      return;
    }
    // const newTabName = `Sheet${tabs.length + 1}`;
    // const newData = new Array(1).fill(new Array(columns.length).fill(''));

    // saveupdatetaskplanexcelsheet({
    //   excelSheetName: newTabName,
    // }).then((res) => {
    //   if (res.data) {
    //     const newTab = {
    //       id: res.data,
    //       name: newTabName,
    //       data: newData,
    //       taskExcelSheetId: res.data,
    //     };
    //     MapData.current = [{}];
    //     setTabs([newTab, ...tabs]);
    //     setActiveTab(res.data);
    //   }
    // });
  };

  // 处理删除
  const handleTabDelete = (tabId) => {
    if (tabs.length > 1) {
      setLoading(true);
      deletetaskplanexcelsheet({ excelSheetId: tabId }).then((res) => {
        setLoading(false);
        if (res.success) {
          const newTabs = tabs.filter((tab) => tab.id !== tabId);
          setTabs(newTabs);
          if (activeTab === tabId) {
            setActiveTab(newTabs[0].id);
            getSheetData(newTabs[0].taskExcelSheetId, newTabs[0].id);
          }
        }
      });
    }
  };

  // 处理重命名
  const handleTabRename = (tabId, newName) => {
    const targetTab = tabs.find((tab) => tab.id === tabId);
    if (targetTab) {
      saveupdatetaskplanexcelsheet({
        taskExcelSheetId: targetTab.taskExcelSheetId,
        excelSheetName: newName,
      }).then((res) => {
        if (res.data) {
          setTabs(
            tabs.map((tab) =>
              tab.id === tabId ? { ...tab, name: newName } : tab,
            ),
          );
        }
      });
    }
  };

  // 获取当前激活的表格数据
  const getCurrentTabData = () => {
    if (tabs.length === 0) return [];
    const activeTabData = tabs.find((tab) => tab.id === activeTab)?.data;
    return Array.isArray(activeTabData) ? activeTabData : [];
  };

  // 处理类目列的联动
  const setCategorySource = ({ columns, row, projectId }) => {
    getProServcatgTree({ projectId }).then((res) => {
      let source = flattenTree(res.data).map((item) => ({
        label: item.servCatgName,
        value: item.proServCatgId,
      }));
      // 修改source
      const customerColumnIndex = columns.findIndex(
        (col) => col.data === 'proServCatgId',
      );
      const customerCell = hotTableComponent.current.hotInstance.getCellMeta(
        row,
        customerColumnIndex,
      );
      // 更新source属性
      customerCell.source = source;
      // 重新渲染表格
      hotTableComponent.current.hotInstance.render();
    });
  };

  // 设置标签的source
  const setTagSource = ({ columns, row, projectId, proServCatgId }) => {
    getTaskTagList({ type: 2, poServCatgId: +proServCatgId }).then((res) => {
      let source = [];
      if (res?.data) {
        source = res.data.map((item) => ({
          label: item.extendData,
          value: item.id,
        }));
      }
      // 修改source
      const tagColumnIndex = columns.findIndex(
        (col) => col.data === 'taskTagList',
      );
      const tagCell = hotTableComponent.current.hotInstance.getCellMeta(
        row,
        tagColumnIndex,
      );
      // 更新source属性
      tagCell.source = source;
      // 重新渲染表格
      hotTableComponent.current.hotInstance.render();
    });
  };

  // 修改wdp项目名的时候处理其他数据
  const projectChange = ({ row, newValue }) => {
    // 设置合同编号
    const contractColumnIndex = columns.findIndex(
      (col) => col.data === 'contractNumber',
    );
    const custCompColumnIndex = columns.findIndex(
      (col) => col.data === 'custName',
    );
    const taskLeaderColumnIndex = columns.findIndex(
      (col) => col.data === 'taskLeader',
    );
    const item = project.userProjectSimpList.find(
      (it) => it.projectId == newValue,
    );
    if (!item) return;
    hotTableComponent.current.hotInstance.setDataAtCell(
      row,
      contractColumnIndex,
      item.contractNumber,
    );
    hotTableComponent.current.hotInstance.setDataAtCell(
      row,
      custCompColumnIndex,
      item.custCompShortName,
    );
    // 设置负责人为项目经理
    // hotTableComponent.current.hotInstance.setDataAtCell(
    //   row,
    //   taskLeaderColumnIndex,
    //   item.projectManager,
    // );
  };

  const handleMemberList = (row) => {
    const mapFun = (teamMemberId, index, item = {}) => ({
      ...item,
      projectId: row.projectId,
      proServCatgId: row._proServCatgId,
      teamMemberId: teamMemberId,
      teamMemberSort: index,
      type: row.taskLeader == teamMemberId ? 1 : 0,
      taskId: row.taskId,
    });

    let { dbTaskTeamMemberList, addTaskTeamMemberList = [] } = row;
    if (!dbTaskTeamMemberList) {
      dbTaskTeamMemberList = [];
    }
    let oldKey = dbTaskTeamMemberList.map((item) => item.teamMemberId);
    let keyArr = addTaskTeamMemberList.split(',');
    const oldTaskTeamMemberList = dbTaskTeamMemberList
      .filter((item) => oldKey.includes(item.teamMemberId))
      .map((item, index) => mapFun(item.teamMemberId, index, item));
    const removeTaskTeamMemberList = dbTaskTeamMemberList
      .filter((item) => !keyArr.includes(item.teamMemberId))
      .map((item, index) => mapFun(item.teamMemberId, index, item));
    let newAddArr = addTaskTeamMemberList
      .split(',')
      .filter((item) => item)
      .filter((item) => !oldKey.includes(item))
      .map((item, index) => mapFun(item, index, {}));
    let params = {
      oldTaskTeamMemberList,
      removeTaskTeamMemberList,
      addTaskTeamMemberList: newAddArr,
      taskTeamMemberNum: addTaskTeamMemberList.split(',').length,
    };
    return params;
  };

  const getRowData = (row) => {
    const taskIdIndex = columns.findIndex((col) => col.data === 'taskId');
    const taskId = hotTableComponent.current.hotInstance.getDataAtCell(
      row,
      taskIdIndex,
    );
    if (!taskId) return MapData.current[row];
    const rowData = MapData.current.find((item) => item.taskId == taskId);
    return rowData ?? {};
  };

  // 单独处理负责人（设置负责人的时候参与人也对应添加）
  const handleTaskLeader = ({ row, newValue }) => {
    const addTaskTeamMemberIndex = columns.findIndex(
      (col) => col.data === 'addTaskTeamMemberList',
    );
    let v =
      hotTableComponent.current.hotInstance.getDataAtCell(
        row,
        addTaskTeamMemberIndex,
      ) ?? '';
    if (!v.includes(newValue)) {
      let value = v + ',' + newValue;
      hotTableComponent.current.hotInstance.setDataAtCell(
        row,
        addTaskTeamMemberIndex,
        value,
      );
    }
  };

  // 设置任务的source
  const setTaskSource = ({ item, row }) => {
    let proServCatgId = item._proServCatgId ?? item.proServCatgId;
    gettorelataskplanpageexcel({
      page: {
        pageNo: 1,
        pageSize: 999,
      },
      projectId: item.projectId,
      proServCatgId,
      excelSheetId: activeTab,
    }).then((res) => {
      console.log(res);
      taskListMap[`${item.projectId}-${proServCatgId}`] = res.data.datas;
      let list = res.data.datas.map((item) => ({
        label: item.taskName,
        value: item.taskId,
      }));
      let taskColumnIndex = columns.findIndex((col) => col.data === 'taskName');
      let taskCell = hotTableComponent.current.hotInstance.getCellMeta(
        row,
        taskColumnIndex,
      );
      taskCell.source = list;
      console.log('设置了任务的列表', taskCell);

      hotTableComponent.current.hotInstance.render();
    });
  };

  const handleTaskName = ({ item, newValue }) => {
    console.log('taskListMap', taskListMap, item);

    let arr =
      taskListMap[
        `${item.projectId}-${item._proServCatgId ?? item.proServCatgId}`
      ] || [];
    let taskItem = arr.find((item) => item.taskId == newValue);
    console.log('handleTaskName', { item, newValue, taskItem });
    if (taskItem) {
      deletetask({ taskId: item.taskId }).then((res) => {
        handleBatchAdd([taskItem]);
      });
      return true;
    }
    return false;
  };

  const handleCellClick = (row, col, rowData) => {
    const colDef = columns[col];
    if (colDef.data === 'proServCatgId') {
      if (rowData && rowData.projectId) {
        setCategorySource({ columns, row, projectId: rowData.projectId });
      }
    }
    if (colDef.data === 'taskTagList') {
      handleTagClick(rowData, row);
      console.log('点击了');
      // let proServCatgId = rowData._proServCatgId ?? rowData.proServCatgId;
      // if (proServCatgId) {
      //   setTagSource({
      //     columns,
      //     row,
      //     projectId: rowData.projectId,
      //     proServCatgId,
      //   });
      // }
    }
  };

  // 表格数据变化时的回调函数
  const handleDataChange = (changes, source) => {
    console.log('source', source, changes);
    if (source == 'custom') return;
    if (changes) {
      const newTabs = [...tabs];
      const currentTab = newTabs.find((t) => t.id === activeTab);
      if (!currentTab) return;

      const newData = [...currentTab.data];
      const apiParams = [];
      let hasCheckedChange = false;

      changes.forEach(([row, prop, oldValue, newValue]) => {
        if (oldValue == newValue) return;

        // Update MapData (Ref)
        if (MapData.current[row]) {
          MapData.current[row][prop] = newValue;
        }

        // Update State Data
        if (newData[row]) {
          newData[row] = { ...newData[row], [prop]: newValue };
        }

        if (prop === 'checked') {
          hasCheckedChange = true;
        }

        const item = getRowData(row);
        let taskNameHandled = false;
        if (prop == 'taskName' && !item._baseData) {
          let b = handleTaskName({ item, newValue });
          if (b) {
            taskNameHandled = true;
          }
        }

        // Prepare API Params only if taskName wasn't fully handled
        if (!taskNameHandled) {
          let optType = TYPE_KEY[prop];
          if (optType != undefined) {
            let value = newValue;
            if (prop == 'taskRfpConfirm') {
              value = +newValue;
            }
            if (prop == 'taskTagList') {
              if (Array.isArray(newValue)) {
                value = newValue.map((tagItem) => {
                  if (tagItem && typeof tagItem === 'object' && tagItem.id) {
                    return { id: tagItem.id };
                  }
                  return { id: tagItem };
                });
              } else {
                value = newValue ? [{ id: newValue }] : [];
              }
            }

            let param = {
              taskExcelExtendId: item.taskExcelExtendId,
              taskId: item.taskId,
              [prop]: value,
              optType: optType,
              taskExcelSheetId: activeTab,
            };

            if (prop == 'proServCatgId') {
              param.projectId = item.projectId;
              item.proServCatgId = newValue;
              console.log('设置_proServCatgId', newValue);

              item._proServCatgId = newValue;
            }
            if (prop == 'taskName') {
              param.projectId = item.projectId;
              param.proServCatgId = item._proServCatgId ?? item.proServCatgId;

              // Set default leader
              const projItem = project.userProjectSimpList.find(
                (it) => it.projectId == item.projectId,
              );
              if (projItem) {
                const taskLeaderColumnIndex = columns.findIndex(
                  (col) => col.data === 'taskLeader',
                );
                hotTableComponent.current.hotInstance.setDataAtCell(
                  row,
                  taskLeaderColumnIndex,
                  projItem.projectManager,
                );
              }
            }
            if (prop == 'addTaskTeamMemberList') {
              let resParams = handleMemberList(item);
              Object.assign(param, resParams);
            }

            apiParams.push(param);
          }
        }

        // Handle Side Effects
        if (prop === 'projectId') {
          projectChange({ row, newValue });
          setCategorySource({ columns, row, projectId: newValue });
        }
        if (prop === 'proServCatgId') {
          console.log('单独处理工作包', MapData.current[row]);
          setTaskSource({ item: MapData.current[row], row });
        }
        if (prop == 'taskLeader') {
          handleTaskLeader({ row, newValue });
        }
      });

      // Update tabs state
      currentTab.data = newData;
      setTabs(newTabs);

      if (hasCheckedChange) {
        const ids = MapData.current
          .filter((item) => !!item.checked && item.taskId)
          .map((item) => item.taskId);
        setSelectedTaskIds(ids);
      }

      // Call API
      if (apiParams.length > 0) {
        console.log(22222);

        saveupdatetaskplanexcel(apiParams).then((res) => {
          if (res.data && res.data.length > 0) {
            // 尝试更新本地数据
            if (changes.length === 1) {
              const savedItem = res.data[0];
              const [row] = changes[0];
              if (savedItem && MapData.current[row]) {
                // 更新本地数据，包括回填taskId等
                MapData.current[row] = {
                  ...MapData.current[row],
                  ...savedItem,
                  proServCatgId:
                    savedItem.proServCatgId ||
                    MapData.current[row].proServCatgId,
                };
                console.log('props', changes);

                setTabs((prevTabs) => {
                  return prevTabs.map((tab) => {
                    if (tab.id === activeTab) {
                      const newData = [...tab.data];
                      if (newData[row]) {
                        newData[row] = {
                          ...newData[row],
                          taskId: savedItem.taskId,
                          _proServCatgId:
                            savedItem.proServCatgId ||
                            newData[row]._proServCatgId ||
                            newData[row].proServCatgId ||
                            MapData.current[row]._proServCatgId ||
                            MapData.current[row].proServCatgId,
                        };
                      }
                      return {
                        ...tab,
                        data: newData,
                      };
                    }
                    return tab;
                  });
                });

                if (changes[0][1] == 'addTaskTeamMemberList') {
                  // Update team members logic
                  let delKeyArr = savedItem.removeTaskTeamMemberList.map(
                    (item) => item.teamMemberId,
                  );
                  MapData.current[row].dbTaskTeamMemberList = uniqueArrayById(
                    savedItem.oldTaskTeamMemberList
                      .concat(savedItem.addTaskTeamMemberList)
                      .filter((item) => !delKeyArr.includes(item.teamMemberId)),
                    'teamMemberId',
                  );
                }
              }
            }
          }

          if (
            !res.success &&
            changes.length === 1 &&
            changes[0][1] == 'taskName'
          ) {
            message.error('任务名称已存在');
            // Revert?
            hotTableComponent.current.hotInstance.setDataAtCell(
              changes[0][0],
              columns.findIndex((col) => col.data === 'taskName'),
              changes[0][2],
              'custom',
            );
          }
        });
      }
    }
  };

  // 表格数据删除
  const handleDataDelete = (index, amount) => {
    const taskIds = [];
    for (let i = index; i < index + amount; i++) {
      if (MapData.current[i]?.taskId) {
        taskIds.push(MapData.current[i].taskId);
      }
    }
    if (taskIds.length > 0) {
      // 删除成功后更新 MapData.current
      MapData.current.splice(index, amount);

      // Update tabs state
      const newTabs = [...tabs];
      const currentTab = newTabs.find((t) => t.id === activeTab);
      if (currentTab) {
        const newData = [...currentTab.data];
        newData.splice(index, amount);
        currentTab.data = newData;
        setTabs(newTabs);
      }

      removetaskplanexceldata({
        excelSheetId: activeTab,
        taskIdList: taskIds,
      }).then((res) => {
        if (!res.success) {
          init(false);
        }
      });
    }
    return true;
  };

  let data = getCurrentTabData();

  // 任务批量添加
  const handleBatchAdd = (rows) => {
    console.log('批量添加');

    saveupdatetaskplanexcel(
      rows.map((item) => ({
        optType: 0,
        taskExcelSheetId: activeTab,
        taskPriority: '2', // Default to Medium
        ...item,
      })),
    ).then((res) => {
      // let data = res.data.map((item, index) => ({
      //   ...item,
      //   proServCatgId: item.servCatgName,
      //   _proServCatgId: item.proServCatgId,
      //   addTaskTeamMemberList: item.dbTaskTeamMemberList
      //     .map((item) => item.teamMemberId)
      //     .join(','),
      //   custName: rows[index]?.custName,
      // }));
      // MapData.current.unshift(...data);
      // let currentTabIndex = tabs.findIndex((item) => item.id === activeTab);
      // tabs[currentTabIndex].data.unshift(...data);
      // hotTableComponent.current.hotInstance.render();

      // setTabs([...tabs]);
      getSheetData(activeTab, activeTab);
    });
  };

  // 本地添加行（不调用接口）
  const handleLocalAdd = (rows = [{}]) => {
    const newRows = rows.map((r) => ({
      taskPriority: '2', // 默认优先级
      taskExcelStatus: '0', // 默认状态为规划
      ...r,
    }));

    const newTabs = tabs.map((tab) => {
      if (tab.id === activeTab) {
        return {
          ...tab,
          data: [...newRows, ...(tab.data || [])],
        };
      }
      return tab;
    });

    MapData.current = [...newRows, ...MapData.current];
    setTabs(newTabs);
  };

  // 处理复制功能
  const handleBeforeCopy = (range) => {
    console.log('handleBeforeCopy range', range);
    let copyItemArr = [];
    for (let i = range.startRow; i <= range.endRow; i++) {
      const item = getRowData(i);
      copyItemArr.push(item);
    }
    console.log('复制数据', copyItemArr, range, MapData.current);
    copyToClipboard(JSON.stringify(copyItemArr));
    return true; // Handled
  };

  const handleBeforePaste = (text, range) => {
    console.log('粘贴数据', text, range);
    if (text.startsWith('[')) {
      console.log('是json数据');

      let dataArr = [];
      try {
        dataArr = JSON.parse(text);
      } catch (e) {
        console.error('Parse paste data error', e);
        return false;
      }

      if (dataArr.length == 0) {
        return false;
      }
      if (dataArr[0].taskExcelSheetId == activeTab) {
        message.error('不允许在同一个sheet中粘贴');
        return true;
      }

      for (let i = 0; i < dataArr.length; i++) {
        if (MapData.current[range.startRow + i]?.taskId) {
          console.log(
            'MapData.current[range.startRow + i]',
            MapData.current[range.startRow + i],
            MapData.current,
          );
          console.log('冲突行：');

          message.error('有冲突的行，请检查后再粘贴');
          return true;
        }
      }
      console.log('11111111');

      saveupdatetaskplanexcel(
        dataArr.map((item) => ({
          taskId: item.taskId,
          taskDockId: item.taskDockId,
          taskRfpConfirm: +item.taskRfpConfirm,
          taskPriority: item.taskPriority,
          taskExcelSheetId: activeTab,
          taskExcelStatus: item.taskExcelStatus,
          taskDoType: item.taskDoType,
        })),
      ).then((res) => {
        getSheetData(activeTab, activeTab);
      });
      return true; // Handled
    }

    // Check if pasting into singleSelect column (prevent it if it's invalid?)
    // Original logic:
    // for (let i = source[0].startCol; i <= source[0].endCol; i++) {
    //   const colItem = columns[i];
    //   if (colItem.type == 'singleSelect') return false;
    // }
    // The original logic returned false to ALLOW paste? Or false to PREVENT?
    // In Handsontable beforePaste, return false cancels paste.
    // Here we return true if we handled it.

    // The original code was:
    // if (colItem.type == 'singleSelect') return false;
    // return true;
    // Wait, in Handsontable hooks, returning false cancels the action.
    // So if it returned false for singleSelect, it prevented paste.
    // But here I'm returning true if I handled it.

    // Let's replicate the check:
    for (let i = range.startCol; i <= range.endCol; i++) {
      const colItem = columns[i];
      // if (colItem.type == 'singleSelect') return true; // Prevent paste (handled as no-op)
      // Actually, let's just let SimpleExcel handle normal text paste.
    }

    return false; // Not handled, let SimpleExcel handle text paste
  };

  // 处理行复制（打开弹窗）
  const handleRowCopy = (rowIndex) => {
    const item = getRowData(rowIndex);
    if (!item || !item.taskId) {
      message.error('请选择有效的任务行');
      return;
    }
    setCurrentCopyTask(item);
    setActionType('copy');
    setCopyModalVisible(true);
  };

  // 处理行移动
  const handleRowMove = (rowIndex) => {
    const item = getRowData(rowIndex);
    if (!item || !item.taskId) {
      message.error('请选择有效的任务行');
      return;
    }
    setCurrentCopyTask(item);
    setActionType('move');
    setCopyModalVisible(true);
  };

  // 处理行引用
  const handleRowRefer = (rowIndex) => {
    const item = getRowData(rowIndex);
    if (!item || !item.taskId) {
      message.error('请选择有效的任务行');
      return;
    }
    setCurrentCopyTask(item);
    setActionType('refer');
    setCopyModalVisible(true);
  };

  // 确认操作（复制/移动/引用）
  const handleActionConfirm = (targetSheetId) => {
    if (!currentCopyTask) return;

    const submitData = {
      sourceExcelSheetId: activeTab,
      targetExcelSheetId: targetSheetId,
      taskIds: [currentCopyTask.taskId],
    };

    setLoading(true);
    let api = copytaskplanexcelrow;
    if (actionType === 'move') api = movetaskplanexcelrow;
    else if (actionType === 'refer') api = refertaskplanexcelrow;

    api(submitData).then((res) => {
      setLoading(false);
      if (res.success) {
        message.success('操作成功');
        setCopyModalVisible(false);
        // 如果是移动，或者目标是当前页，刷新当前页
        if (actionType === 'move' || targetSheetId === activeTab) {
          getSheetData(activeTab, activeTab);
        }
        // 如果目标不是当前页，刷新目标页（如果已加载）
        if (targetSheetId !== activeTab) {
          const targetTab = tabs.find((t) => t.id === targetSheetId);
          if (targetTab && targetTab.data && targetTab.data.length > 0) {
            getSheetData(targetTab.taskExcelSheetId, targetTab.id);
          }
        }
      }
    });
  };
  console.log('selectedTaskIds', selectedTaskIds);

  return (
    <div className="excel-pro" tabIndex={99}>
      {/* <Button type="primary" onClick={() => init(false)}>
        重置
      </Button> */}
      <OperationBar
        hotTableRef={hotTableComponent}
        MapData={MapData}
        tabs={tabs}
        taskExcelSheetId={activeTab}
        onBatchAdd={handleBatchAdd}
        onLocalAdd={handleLocalAdd}
        selectedTaskIds={selectedTaskIds}
      />
      <PageLoading style={{ display: pageLoading ? 'flex' : 'none' }} />
      <RptModal
        visible={rptModalVisible}
        getHasRptTime={getHasRptTime}
        selectRows={selectRows}
        reportDate={state.reportDate}
        usercenter={usercenter}
        loading={loading['usercenter/reportEmpWork']}
        onSave={rptSave}
        timeData={timeData}
        onCancel={() => setRptModalVisible(false)}
      />
      <ServiceCategoryModal
        visible={tagModalVisible}
        checkedKeys={currentTagValue}
        onCancel={() => setTagModalVisible(false)}
        onOk={handleTagSave}
      />
      <CopyTaskModal
        visible={copyModalVisible}
        onCancel={() => setCopyModalVisible(false)}
        onOk={handleActionConfirm}
        tabs={tabs}
        currentTask={currentCopyTask}
        title={
          actionType === 'move'
            ? '移动任务'
            : actionType === 'refer'
            ? '引用任务'
            : '复制任务'
        }
      />
      <SimpleExcel
        ref={hotTableComponent}
        data={data || []}
        columns={columns}
        onChange={handleDataChange}
        height="calc(100vh - 230px)"
        disabled={disabled}
        activeTab={activeTab}
        onRowRemove={handleDataDelete}
        onCellClick={handleCellClick}
        onCopy={handleBeforeCopy}
        onPaste={handleBeforePaste}
        onRowCopy={handleRowCopy}
        onRowMove={handleRowMove}
        onRowRefer={handleRowRefer}
      />
      <TabsComponent
        disabled={disabled}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        onTabAdd={handleTabAdd}
        onTabDelete={handleTabDelete}
        onTabRename={handleTabRename}
        tabs={tabs}
      />
    </div>
  );
};

export default connect(({ project, customer, usercenter, loading }) => ({
  project,
  customer,
  usercenter,
  loading: loading.effects,
}))(ExcelPro);
